import AzureAdLogin from "../aad/AzureAdLogin";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import {useEffect, useState} from "react";
import {SilentRequest} from "@azure/msal-browser";
import {loginRequest} from "../aad/authConfig";
import styled from "@emotion/styled/macro";

const LoginMain = styled.main`

    display:flex;
    align-items:center;
    justify-content: center;
    text-align:center;
    
`

const IndexLogin: React.FC<{hasLoggedIn:boolean, setHasLoggedIn: (hasLoggedIn:boolean|string) => void}> = (props) => {
    const isAuthenticated = useIsAuthenticated();
    const { hasLoggedIn, setHasLoggedIn } = props;
    const { instance, accounts } = useMsal();
    //instance.acquireTokenByCode()
    useEffect(() => {
        console.log('Running effect');

        if (isAuthenticated && !hasLoggedIn) {
            const request: SilentRequest = {...loginRequest, account: accounts[0]};
            instance.acquireTokenSilent(request).then(res => {
                fetch('/auth/azuread', { method: 'POST', headers: { "Authorization": "Bearer " + res.accessToken}}).then(x => {
                    if (x.ok) {
                        setHasLoggedIn(true)
                    } else {
                        setHasLoggedIn(`Unable to log in. Try reloading the page and trying again (error ${x.status})`);
                    }
                });

            }).catch(e => {
                instance.acquireTokenPopup(request).then(resp => {
                    fetch('/auth/azuread', { method: 'POST', headers: { "Authorization": "Bearer " + resp.accessToken}}).then(x => {
                        if (x.ok) {
                            setHasLoggedIn(true)
                        } else {
                            setHasLoggedIn(`Unable to log in. Try reloading the page and trying again (error ${x.status})`);
                        }
                    });
                })
            })
        }
    }, [isAuthenticated, hasLoggedIn])
    return <LoginMain>


        <div className={'content'}>
        <img src={"ClaytonVSC.jpg"} />

        { !isAuthenticated && <AzureAdLogin /> }
        { isAuthenticated && !hasLoggedIn && <div>Logging in...</div> }
        </div>

    </LoginMain>

}
export default IndexLogin;